module.exports = {
    appeventConstants: {
        bookTicketsResultEventName : "BookTicketsResult",
        relaunchEventName : "RelaunchOpenAgent",
    },
};


// WEBPACK FOOTER //
// ./settings/appevent-constants.js